import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Landing } from "@/Landing";
import AdminDashboard from "@/components/AdminDashboard";
import BuilderPage from "@/builder/BuilderPage";

function RefRedirect() {
  const { slug } = useParams();
  const search = new URLSearchParams(window.location.search);
  search.set("ref", slug || "");
  return <Navigate to={`/?${search.toString()}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/builder" element={<BuilderPage />} />
        <Route path="/r/:slug" element={<RefRedirect />} />
      </Routes>
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
